import React from 'react'
import ProductsMovementsListEssay from './components/Movements_list'

function ProductsMovementsEssay() {
  return (
    <div>
        <ProductsMovementsListEssay />
    </div>
  )
}

export default ProductsMovementsEssay
